import React, { useEffect } from 'react';

const Blog5: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <article className="max-w-6xl mx-auto p-6 mt-28 bg-white shadow-lg rounded-lg mb-8">
            <h1 className="text-3xl font-bold mb-2">Sciatica Relief Roadmap – From Pain Causes to Minimally Invasive Fixes</h1>
            <div className="text-gray-600 mb-4">
                🗓️ <span>15th February, 2026</span>
            </div>

            <img src='/images/blog5.png' alt="Sciatica Relief Roadmap" className="w-full h-80 object-contain rounded-lg mb-6" />

            <div className="prose max-w-none">
                <p>
                    Picture sharp, shooting pain from your lower back down one leg, like an electric jolt that worsens when sitting or coughing – that's sciatica, affecting 40% of adults at some point. It happens when the sciatic nerve, your body's longest (as thick as your thumb, running from spine to foot), gets squeezed by a bulging disc, bone spur from arthritis, or spinal stenosis narrowing the canal. Risk factors include desk jobs with poor posture, heavy lifting, pregnancy weight, diabetes thickening ligaments, or even smoking that stiffens discs. Unlike muscle strains, sciatica brings numbness, tingling like "pins and needles," or foot drop where you can't lift your toes while walking.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">Don't Ignore the Pain</h2>
                <p>
                    Don't ignore it – untreated, it can weaken leg muscles permanently. Start with self-care: rest 1-2 days max (bed rest worsens it), then gentle stretches like knee-to-chest pulls or piriformis massage if tight butt muscles pinch the nerve. Over-the-counter ibuprofen reduces inflammation, and hot/cold packs ease spasms – 20 minutes each, alternating. Physical therapy shines here: a therapist teaches core-strengthening planks, hamstring stretches, and walking programs to offload the nerve, with 80% improving in 4-6 weeks.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">When to See a Specialist</h2>
                <p>
                    If pain lingers beyond 6 weeks or you lose bladder control (a red flag for cauda equina emergency), see Dr. Gunjan. Diagnosis uses straight-leg raise tests reproducing pain, EMG nerve conduction studies measuring signal speed, and MRI revealing the exact pinch spot. Conservative options extend to epidural steroid shots – a needle delivers cortisone near the nerve, shrinking swelling for 3-6 months relief in 70% of cases.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">Minimally Invasive Solutions</h2>
                <p>
                    When conservative measures fail to relieve progressive neurological deficits or persistent sciatic pain, minimally invasive spine surgery may be evaluated. Procedures such as tubular microdiscectomy allow the surgeon to relieve nerve root compression through a small incision while minimizing disruption to surrounding paraspinal musculature. Postoperative recovery involves tailored physiotherapy, ergonomic posture adjustments, and gradual resumption of physical activity under clinical supervision.
                </p>
            </div>

            <button className="mt-6 bg-blue-800 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded">
                Schedule Appointment
            </button>
        </article>
    );
};

export default Blog5;
